<template>
	<div class="header">
		<!-- 左边头部信息 -->
		<div class="today">{{ date | fnFormatDate }}</div>
		<!-- 中间项目名称信息 -->
		<div class="center-box" :title="title">{{ title }}</div>
		<!-- 右边项目设置信息 -->
		<!-- 设置 -->
		<div class="set_box">
			<el-dropdown class="avatar-container right-menu-item hover-effect" trigger="click">
				<div>
					<img class="set_img" src="../../../assets/img/enter_head_set.png" />
					<div class="set">设置</div>
				</div>
				<el-dropdown-menu slot="dropdown" style="background-color: rgba(29,68,149,0.3);border: 1px solid rgba(29, 68, 149, 1);">
					<el-dropdown-item divided style="text-align: center"><div @click="enterVisible=true">企业名称</div></el-dropdown-item>
					<el-dropdown-item divided style="text-align: center"><div @click="fnOpenAddOrEdit">发送消息通知</div></el-dropdown-item>
					<el-dropdown-item divided style="text-align: center"><div @click="fnOpenMessage">查看已发消息</div></el-dropdown-item>
					<el-dropdown-item divided style="text-align: center"><div @click="fnOpenPwd">修改密码</div></el-dropdown-item>
					<el-dropdown-item divided style="text-align: center"><div @click="logoutEnter">退出登录</div></el-dropdown-item>
				</el-dropdown-menu>
			</el-dropdown>
		</div>

		<!-- 添加表单时的弹出层 -->
		<div class="dialog_send_msg" v-if="dialogFormVisible">
			<el-dialog title="消息通知" :custom-class="'animate__animated animate__fadeIn'" :modal="false" :visible.sync="dialogFormVisible" center>
				<el-form :model="form">
					<el-form-item label="内容" :label-width="formLabelWidth">
						<Tinymce ref="editRich" v-model="form.cont"></Tinymce>
					</el-form-item>
					<el-form-item label="项目" :label-width="formLabelWidth">
						<el-select v-model="form.project" clearable :popper-append-to-body="false" multiple collapse-tags placeholder="请选择项目" @change="changeProject">
							<el-option v-for="item in projectArr" :key="item.id" :label="item.name" :value="item.id"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="排除项目" :label-width="formLabelWidth">
						<el-select v-model="form.eliminate" clearable :popper-append-to-body="false" multiple collapse-tags placeholder="请选择排除项目">
							<el-option v-for="item in projectNotArr" :key="item.id" :label="item.name" :value="item.id"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="推送APP" :label-width="formLabelWidth">
						<el-radio-group v-model="form.is_push_app" size="medium">
							<el-radio border :label="1">是</el-radio>
							<el-radio border :label="0">否</el-radio>
						</el-radio-group>
					</el-form-item>
				</el-form>
				<div slot="footer" class="dialog-footer">
					<div class="btn_line">
						<div class="search-btn red" @click="fnCloseAddOrEdit"><span>取消</span></div>
						<div class="search-btn" @click="fnAdd"><span>保存</span></div>
					</div>
				</div>
			</el-dialog>
		</div>
        <!-- 修改密码 -->
        <div class="dialog_pwd" v-if="dialogEditPwd">
        	<el-dialog title="修改密码" :custom-class="'animate__animated animate__fadeIn'" :modal="false" :visible.sync="dialogEditPwd" center>
        		<el-form :model="formPwd">
        			<el-form-item label="旧密码" label-width="100px">
                        <el-input v-model="formPwd.old_password" show-password placeholder="请输入旧密码"></el-input>
        			</el-form-item>
        			<el-form-item label="新密码" label-width="100px">
        				<el-input v-model="formPwd.new_password" show-password placeholder="请输入新密码"></el-input>
        			</el-form-item>
        			<el-form-item label="再次输入密码" label-width="100px">
        				<el-input v-model="formPwd.pass_again" show-password placeholder="请再次输入密码"></el-input>
        			</el-form-item>
        		</el-form>
        		<div slot="footer" class="dialog-footer">
        			<div class="btn_line">
        				<div class="search-btn red" @click="dialogEditPwd=false"><span>取消</span></div>
        				<div class="search-btn" @click="fnEditPwd"><span>保存</span></div>
        			</div>
        		</div>
        	</el-dialog>
        </div>
		<!-- 查看消息列表 -->
		<div class="dialog_msg_list" v-if="showMessageAll">
			<el-dialog title="消息列表" :custom-class="'animate__animated animate__fadeIn'" :modal="false" center :visible.sync="showMessageAll">
				<div class="cont_list">
					<div class="list_title">
						<div class="title_item">内容</div>
						<div class="title_item">项目</div>
						<div class="title_item">排除项目</div>
						<div class="title_item">创建时间</div>
						<div class="title_item">推送APP</div>
					</div>
					<div class="list_boxes">
						<div class="list_box">
							<div v-if="MessageData">
								<div class="box_line" v-for="(item,index) in MessageData" :key="index">
									<div class="list_item contentmsg">
										<div class="msg_box" v-html="item.content"></div>
									</div>
									<div class="list_item" :title="fnRePro(item.project_id)"><span>{{fnRePro(item.project_id)}}</span></div>
									<div class="list_item" :title="fnRePro(item.not_project_id)"><span>{{fnRePro(item.not_project_id)}}</span></div>
									<div class="list_item" :title="item.create_at"><span>{{ item.create_at }}</span></div>
									<div class="list_item">{{ item.is_push_app ? '已推送' : '未推送' }}</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div slot="footer" class="dialog-footer">
					<div class="btn_line">
						<div class="search-btn red" @click="showMessageAll = false"><span>关闭</span></div>
					</div>
				</div>
			</el-dialog>
		</div>
		<!-- 设置电视APP公告弹窗 -->
		<div class="dialog_enter_name" v-if="enterVisible">
			<el-dialog title="企业名称" :custom-class="'animate__animated animate__fadeIn'" :modal="false" :visible.sync="enterVisible" center width="350px">
				<div style="text-align: center">
					<el-input v-model="title" placeholder="请输入企业名称"></el-input>
				</div>
				<div slot="footer" class="dialog-footer">
					<div class="btn_line">
						<div class="search-btn red" @click="enterVisible = false"><span>取消</span></div>
						<div class="search-btn" @click="fnSaveEnter"><span>保存</span></div>
					</div>
				</div>
			</el-dialog>
		</div>
	</div>
</template>
<script>
import APP from '@/utils/base';
import request from '@/utils/enter';//企业端请求
import { removeToken, removeEnterToken, removeUserInfo, removeEnterInfo, getEnterInfo, setEnterInfo } from '@/utils/auth';
import axios from 'axios';
import Tinymce from '@/components/Tinymce/index'
export default {
	data() {
		return {
			date: new Date(), // 当前时间
			enterInfo: null, // 登录后缓存的企业信息
			title: '', // 企业名称
			form: {
			  cont: "", // 内容 -> 对话框
				project:[], // 项目 -> 对话框
				eliminate:[], // 排除 -> 对话框
				is_push_app: 0, // 推送APP -> 对话框
			},
            dialogEditPwd: false,
            formPwd:{
                old_password: '',// 旧密码
                new_password: '',// 新密码
                pass_again: '',// 二次密码
            },
			formLabelWidth: "120px", // 弹窗label宽度
			projectArrAll: [],// 项目
			projectArr: [], // 项目
			projectNotArr: [],// 排除项目
			projectObj:{}, // 项目
			dialogFormVisible: false,// 发送通知弹窗
			showMessageAll: false,// 查看发送的消息通知弹窗
			MessageData: [],// 消息列表
			enterVisible: false,//企业名称弹窗
		};
	},
	components:{
		Tinymce
	},
	created() {
		// 获取企业信息
		this.enterInfo = getEnterInfo();
		this.title = this.enterInfo.name
	},
	beforeDestroy() {
		if (this.timer) {
			clearInterval(this.timer);
		}
	},
	mounted() {
		this.fnInit()
	},
	methods: {
        // 打开修改密码弹窗
        fnOpenPwd(){
            this.formPwd.old_password = ''
            this.formPwd.new_password = ''
            this.formPwd.pass_again = ''
            this.dialogEditPwd = true
        },
        // 修改密码 保存
        fnEditPwd(){
            if(!this.formPwd.old_password) return this.$message.warning('旧密码不能为空!')
            if(!this.formPwd.new_password) return this.$message.warning('新密码不能为空!')
            if(!this.formPwd.pass_again) return this.$message.warning('再次输入密码不能为空!')
            if(this.formPwd.new_password!=this.formPwd.pass_again) return this.$message.warning('两次密码不一致,请重新输入!')
            let _obj = {
                old_password: this.formPwd.old_password,
                new_password: this.formPwd.new_password
            }
            request({
              url: '/password/edit_enterprise',
              method: 'POST',
              data: _obj
            }).then(res => {
                this.$message.success(res.data+',2秒后请重新登录!')
                setTimeout(()=>{
                     this.logoutEnter()
                },2000)
            }).catch(err => {
              this.$message.error(err.data)
            })
        },
		// 退出登录
		async logoutEnter() {
			await
			removeEnterToken();
			removeEnterInfo();
			removeToken();
			removeUserInfo();
			this.$router.push(`/login`);
			location.reload();
		},
		// 初始化
		fnInit(){
			// 获取企业下项目
			this.getProject();
			// 获取当前时间
			let _that = this;
			this.timer = setInterval(function() {
				_that.date = new Date();
			}, 1000);
		},
		// 获取项目选项/排除项目选项
		getProject(){
			request({
			  url: 'enterprice/getProjectInEnter',
			  method: 'GET',
			}).then(res => {
				let _data = res.data
				let _obj = {}
				for(var i=0;i<_data.length;i++){
					_data[i].id = "&"+_data[i].id+";"
					_obj[_data[i].id] = _data[i].name
				}
				this.projectArrAll = JSON.parse(JSON.stringify(_data))
				this.projectArr = _data
				this.projectNotArr = _data
				this.projectObj = _obj
			}).catch(err => {
			  this.$message.error(err.data)
			})
		},
		// 项目数据处理
		fnRePro(val){
			if(val){
				var _arr = val.split(";")
				var _str = []
				for(var i=0;i<_arr.length;i++){
					_arr[i] = _arr[i]+';'
					if(this.projectObj[_arr[i]]){
						_str.push(this.projectObj[_arr[i]])
					}
				}
				return _str.join(',')
			}else{
				return ''
			}
		},
		// 处理排除项目选项
		changeProject(val){
			let _arr = JSON.parse(JSON.stringify(this.projectArrAll))
			if(val.length>0){
				for(var i in val){
					for(var j in _arr){
						if(_arr[j].id == val[i]){
							_arr.splice(j,1);
						}
					}
				}
				this.projectNotArr = _arr
			}
		},
		// 打开消息列表弹窗
		fnOpenMessage(){
			request({
			  url: 'enterprice/getALLMessage',
			  method: 'GET',
			}).then(res => {
                if(res.code == 1){
                    this.MessageData = res.data
                    this.showMessageAll = !this.showMessageAll
                }
			}).catch(err => {
			  this.$message.error(err)
			})
		},
		// 打开添加弹窗
		fnOpenAddOrEdit(){
		  this.dialogFormVisible = true
		  this.form.cont = ''
			this.form.project = []
			this.form.eliminate = []
			this.form.is_push_app = 0
			setTimeout(()=>{
				this.$refs.editRich.setContent('')
			},100)
		},
		// 关闭添加弹窗
		fnCloseAddOrEdit(){
		  this.form.cont = ''
			this.form.project = []
		  this.form.eliminate = []
			this.form.is_push_app = 0
			setTimeout(()=>{
				this.$refs.editRich.setContent('')
			},100)
			this.dialogFormVisible = false
		},
		// 添加内容
		fnAdd() {
		  if( !this.form.cont ){
		    this.$message.warning('内容不能为空')
		    return
		  }
		  let _data = {
		    content : this.form.cont,
				project_id : this.form.project?this.form.project.join(''):'',
				not_project_id : this.form.eliminate?this.form.eliminate.join(''):'',
				is_push_app : this.form.is_push_app
		  }
		  request({
		    url: "enterprice/editMessage",
		    method: 'POST',
		    data: _data
		  }).then(res => {
		    this.$message.success(res.data)
		    this.fnInit()
		    this.fnCloseAddOrEdit()
		  }).catch(err => {
		    this.$message.error(err.data)
		    this.fnCloseAddOrEdit()
		  })
		},
		// 保存企业名称
		fnSaveEnter(){
			// if(this.title.length > 5){
			// 	this.$message.warning("设置的企业名称不能超过5个字！")
			// 	return
			// }
			let _data = {
				name: this.title
			}
			request({
			  url: "setting/setEnterName",
			  method: 'POST',
			  data: _data
			}).then(res => {
				this.enterInfo.name = this.title
				setEnterInfo(this.enterInfo)
				this.enterVisible = false
				this.$message.success(res.data)
			}).catch(err => {
			  this.$message.error(err.data)
			})
		},
		// 路由跳转
		fnRefresh(_url) {
			if (_url === this.$route.path) {
				this.$router.push({
					path: '/redirect',
					query: _url
				});
			} else {
				this.$router.push({
					path: _url
				});
			}
		},
	}
};
</script>
<style lang="scss" scoped>
@import '@/styles/mixin.scss';
.header {
	width: 1920px;
	height: 120px;
	background-image: url(../../../assets/img/enter_head_line.png);
	background-size: 100%;
	background-position: 0 0;
	position: absolute;
	top: 0;
	left: 0;
	.today{
		position: absolute;
		left: 33px;
		top: 16px;
		width: 160px;
		height: 20px;
		line-height: 20px;
		font-size: 14px;
		color: #9CF8FB;
		cursor: pointer;
		@include flex-box(center, center);
	}
	.center-box {
		position: absolute;
		left: 578px;
		top: 0;
		width: 760px;
		height: 70px;
		font-size: 40px;
		line-height: 90px;
		color: #9CF8FB;
		cursor: pointer;
		text-align: center;
		padding: 0 10px;
		@include text-overflow();
	}
	.set_box{
		position: absolute;
		width: 60px;
		height: 20px;
		left: 1850px;
		top: 16px;

		.set_img {
			width: 17px;
			height: 17px;
			margin-top: 2px;
			float: left;
			margin-right: 10px;
		}
		.set {
			height: 20px;
			width: 30px;
			font-size: 14px;
			color: #9CF8FB;
			cursor: pointer;
			float: left;
		}
	}
}
>>>.el-dropdown-menu__item--divided{
	border-top: rgba(29,68,149,0.3);
	color: #9CF8FB;
}
>>>.el-dropdown-menu__item--divided::before{
	background-color: rgba(29,68,149,0.3);
	height: 0;
}
>>>.popper__arrow{
	border-bottom-color: rgba(29,68,149,1)!important;
}
.dialog_enter_name,.dialog_msg_list,.dialog_send_msg,.dialog_pwd{
	.btn_line{
		@include flex-box(center,center);
	}
	>>>.el-dialog{
		margin-top: 35vh !important;
		background-color: rgba(9, 17, 32, 1);
		border: 1px solid #3a74dd;
	}
	>>>.el-form-item__label{
		color: #4DB4F4;
	}
	>>>.el-dialog__title{
		color: #4DB4F4;
	}
	>>>.el-input__inner{
		width: 280px;
		height: 30px;
		border-radius: 2px;
		border: none;
		color: rgba(77, 180, 244, 0.7);
		background-color: rgba(77, 180, 244, 0.2);
		&::-webkit-input-placeholder{
			color: rgba(77, 180, 244, 0.7);
		}
		&::-moz-placeholder{   /* Mozilla Firefox 19+ */
			color: rgba(77, 180, 244, 0.7);
		}
		&:-moz-placeholder{    /* Mozilla Firefox 4 to 18 */
			color: rgba(77, 180, 244, 0.7);
		}
		&:-ms-input-placeholder{  /* Internet Explorer 10-11 */
			color: rgba(77, 180, 244, 0.7);
		}
	}
	>>>.el-dialog__close{
		color: #4DB4F4;
	}
	>>>.el-select {
		.el-input {
			.el-select__caret{
				color: rgba(77, 180, 244, 0.7);
			}
		}
	}
	>>>.el-select-dropdown{
		background-color: rgba(9, 17, 32, 0.5);
		border: 1px solid rgba(77, 180, 244, 1);

		background-color: rgba(9, 17, 32, 1);
		border: 1px solid rgba(77, 180, 244, 1);
	}
	>>>.el-select-dropdown__item{
		color: rgba(77, 180, 244, 0.7);
	}
	>>>.el-select-dropdown__item:hover{
			color:#409eff;
	}
	>>>.el-select-dropdown__item.hover{
			color:#409eff;
	}
	>>>.el-dropdown-menu__item--divided{
		border-top: rgba(29,68,149,0.5);
		color: #9CF8FB;
	}
	>>>.el-dropdown-menu__item--divided::before{
		background-color: rgba(29,68,149,0.5);
		height: 0;
	}
	>>>.popper__arrow{
		border-bottom-color: rgba(77, 180, 244, 1)!important;
	}

}
.dialog_pwd{
    >>>.el-dialog{
    	width: 600px;
        height: 350px;
    	margin-top: 25vh !important;
    }
    >>>.el-input__inner{
    	width: 380px;
    	height: 30px;
    	border-radius: 2px;
    	border: none;
    	color: rgba(77, 180, 244, 0.7);
    	background-color: rgba(77, 180, 244, 0.2);
    	&::-webkit-input-placeholder{
    		color: rgba(77, 180, 244, 0.7);
    	}
    	&::-moz-placeholder{   /* Mozilla Firefox 19+ */
    		color: rgba(77, 180, 244, 0.7);
    	}
    	&:-moz-placeholder{    /* Mozilla Firefox 4 to 18 */
    		color: rgba(77, 180, 244, 0.7);
    	}
    	&:-ms-input-placeholder{  /* Internet Explorer 10-11 */
    		color: rgba(77, 180, 244, 0.7);
    	}
    }
}
.dialog_msg_list{
	>>>.el-dialog{
		width: 910px;
		margin-top: 25vh !important;
	}
	.cont_list{
		width: 860px;
		height: 350px;
		color: #FFFFFF;
		font-size: 16px;
		border-radius: 10px;
		background-color: rgba(29, 68, 149, 0.1);
		.list_title{
			width: 860px;
			height: 48px;
			background: url(../../../assets/img/per_list_bg.png) no-repeat;
			background-size: 100% 100%;
			@include flex-box(flex-start,center);
			.title_item{
				height: 48px;
				@include flex-box(center,center);
				&:nth-child(1){
					width: 308px;
					margin-right: 2px;
					margin-left: 30px;
				}
				&:nth-child(2){
					width: 116px;
					margin: 0 2px;
				}
				&:nth-child(3){
					width: 116px;
					margin: 0 2px;
				}
				&:nth-child(4){
					width: 126px;
					margin: 0 2px;
				}
				&:nth-child(5){
					width: 118px;
					margin-left: 2px;
					margin-right: 30px;
				}
			}
		}
		.list_boxes{
			width: 800px;
			height: 302px;
			margin-left: 30px;
			position: relative;
			overflow: hidden;
			.list_box{
				position: absolute;
				left: 0;
				right: -25px;
				top: 0;
				bottom: 0;
				overflow-x: hidden;
				overflow-y: auto;
				.box_line{
					width: 800px;
					height: 70px;
					margin: 5px 0 0 0px;
					border-bottom: 1px dashed #1D4495;
					@include flex-box(flex-start,center);
					.list_item{
						height: 70px;
						text-align: center;
						@include flex-box(center,center);
						&:nth-child(1){
							width: 308px;
							margin-right: 2px;
						}
						&:nth-child(2){
							width: 116px;
							margin: 0 2px;
						}
						&:nth-child(3){
							width: 116px;
							margin: 0 2px;
						}
						&:nth-child(4){
							width: 126px;
							margin: 0 2px;
						}
						&:nth-child(5){
							width: 118px;
							margin-left: 2px;
						}
						&.contentmsg{
							width:308px;
							max-height: 70px;
							position: relative;
							overflow: hidden;
							.msg_box{
								position: absolute;
								left: 0;
								right: -25px;
								top: 0;
								bottom: 0;
								overflow-x: hidden;
								overflow-y: auto;
							}
						}
						span{
							width: 100%;
							cursor: pointer;
							overflow: hidden;
							text-overflow: ellipsis;
							white-space:nowrap;
						}
					}
				}
			}
		}
	}
}
.dialog_send_msg{
	>>>.el-dialog{
		margin-top: 10vh !important;
	}
	>>>.el-input__inner{
		width: 450px;
	}
}
</style>



// WEBPACK FOOTER //
// src/views/Header/HeaderDefault/headerEnterprise.vue